// extracted by mini-css-extract-plugin
module.exports = {"item":"BlockNavbar_item_2LS9r","active":"BlockNavbar_active_opyOP"};